import { balanceColor } from "../../utils/helper";

// ── sub-components ────────────────────────────────────────────────────────────
export const KpiCard = ({ label, value, sub, color }) => (
  <div
    style={{
      background: "var(--color-background-secondary)",
      borderRadius: "var(--border-radius-md)",
      padding: "12px 14px",
      flex: 1,
      minWidth: 0,
    }}
  >
    <div
      style={{
        fontSize: 11,
        color: "var(--color-text-secondary)",
        marginBottom: 4,
        fontWeight: 500,
        letterSpacing: "0.03em",
      }}
    >
      {label}
    </div>
    <div
      style={{
        fontSize: 18,
        fontWeight: 500,
        color: color || "var(--color-text-primary)",
      }}
    >
      {value}
    </div>
    {sub && (
      <div
        style={{
          fontSize: 11,
          color: "var(--color-text-tertiary)",
          marginTop: 2,
        }}
      >
        {sub}
      </div>
    )}
  </div>
);

export const Badge = ({ type }) => {
  const c = balanceColor(type);
  return (
    <span
      style={{
        background: c.bg,
        color: c.text,
        border: `0.5px solid ${c.border}`,
        borderRadius: 99,
        fontSize: 11,
        fontWeight: 500,
        padding: "2px 10px",
        display: "inline-block",
      }}
    >
      {type}
    </span>
  );
};

export const ValidationDot = ({ ok }) => (
  <span
    style={{
      display: "inline-block",
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: ok ? "#22c55e" : "#ef4444",
      marginRight: 6,
    }}
  />
);
